const LAST_SPACE_IN_STRING_REGEX = /([^\s])\s+([^\s]+)\s*$/;

/**
 * Finds the last space in a string and replaces it with the
 * unicode for a non-breaking space.
 *
 * @param{string} text
 * @returns{string}
 */
export const avoidWidows = (text) => {
  const nonBreakingSpace = '\u00A0';
  return text.replace(LAST_SPACE_IN_STRING_REGEX, `$1${nonBreakingSpace}$2`);
};
